import { Cloud, VideoLibrary } from '@mui/icons-material';
import React from 'react';
import './About.css';

function About() {
  return <div className='about'>
            <h2 >About</h2>
            <p>This website serves as both a test for various reactJS features, as well as a self
                promotional music website. 
                <br/><br/>
                I was born on March 13, 1999 in Hershey PA. I grew up pretty much on the computer, listening to music
                all the time on youtube. Naturally being on the computer all the time, I was also into programming, which
                led me to get my degree in IST at Penn State in 2021.
                <br/><br/>
                My music is inspired from various sources, I try not to stay too one dimensional. I take inspiration from
                classical composers like Erik Satie, and some more modern musicians like Com Truise, Kid Cudi, Kanye West, Kavinsky, and the list goes on.
                I like to take inspiration from the 80's as well, with some influences being Cocteau Twins, Tears for fears, and a-ha.
                <br/><br/>
                Hopefully you check out my music! It would be greatly appreciated!
            </p>


            <a href='https://soundcloud.com/blooflazh'>                
                <img className='linkicon' src='https://cdn2.iconfinder.com/data/icons/minimalism/512/soundcloud.png'/>
            </a>

            <a href='https://www.youtube.com/channel/UCrVWNo93Pafoug1_n5EF9VA'>
                <img className='linkicon' src='https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/2560px-YouTube_full-color_icon_%282017%29.svg.png'/>
            </a>
            <a href='https://www.linkedin.com/in/kdangleben/'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/61/61109.png'/>
            </a>

            <a href='https://github.com/kamerond1899'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/25/25231.png'/>
            </a>
            <a href='https://open.spotify.com/artist/2bXv1kmGXiELGMrX2DoLW6?si=wWv-ZJ2uRQeL2nfPRdhGYw'>
                <img className='linkicon' src='https://cdn-icons-png.flaticon.com/512/174/174872.png'/>
            </a>
            <br/>
            <iframe src="https://www.youtube.com/embed/d0qdx0QQ9ec" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>;
}

export default About;
